import { SessionTokenRequestSigner } from '@studyportals/client-internal-platform-sso';
import { SignedRequestSender } from '@studyportals/mb-platform-http-requests';
import UserSession from '@/infrastructure/user-session';

const requestSigner = new SessionTokenRequestSigner(UserSession.userSessionOperations);
const requestSender = new SignedRequestSender(requestSigner);

export default requestSender;
